import request from '@/utils/request'

const userApi = {
  Login: '/receiving/oauth',
  Logout: '/public/logout',
  GET_STAFF_BY_TOKEN: '/receiving/get-user-info'
}

/**
 * login func
 * @param data
 * @returns {*}
 */
export function login (data) {
  return request({
    url: userApi.Login,
    method: 'post',
    data
  })
}

export function logout (data) {
  return request({
    url: userApi.Logout,
    method: 'post',
    data
  })
}

export function getUserInfoByToken(data) {
  return request({
    url: userApi.GET_STAFF_BY_TOKEN,
    method: 'get',
    data
  })
}

export default {
  login,
  logout,
  getUserInfoByToken
}
